/* eslint-disable ember/no-computed-properties-in-native-classes */
import { action, computed } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismCheckbox,
  PrismIcon,
  PrismTooltip,
} from '@mylighthouse/prism-ember';

interface SettingsHotelAccessFormsAccessRightsCheckboxSignature {
  Args: {
    column: unknown;
    row: unknown;
  };
}

export default class SettingsHotelAccessFormsAccessRightsCheckbox extends Component<SettingsHotelAccessFormsAccessRightsCheckboxSignature> {
  @service declare intl: Services['intl'];

  @computed('args.row.products.{rate_insight,revenue_insight}.is_accessible')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get accessibleProductCount() {
    if (this.args.row !== undefined) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      return Object.keys(this.args.row.products).reduce(
        (total, currentProduct) => {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          if (this.args.row.products[currentProduct].is_accessible) {
            return total + 1;
          }
          return total;
        },
        0,
      );
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hoverTooltipMessage() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!this.product || !this.product.is_accessible) {
      return this.intl.t('settings.hotel_access.edit.no_product.tooltip_text');
    }

    // if is editable, we show the tooltip
    if (!this.isNotEditable) {
      return this.intl.t(
        'settings.hotel_access.edit.multiple_selections.tooltip_text',
      );
    }
    return this.intl.t('settings.hotel_access.edit.has_product.tooltip_text');
  }

  @computed(
    'args.row.{accessRight,isSelected}',
    'product.is_editable',
    'isLastAccessibleProduct',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDisabled() {
    if (this.args.row !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return (
        // @ts-expect-error: Incorrect type
        this.args.row.accessRight === 'admin' ||
        // @ts-expect-error: Incorrect type
        this.args.row.isSelected ||
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        !this.product.is_editable ||
        this.isLastAccessibleProduct
      );
    }

    return false;
  }

  @computed('accessibleProductCount', 'product.is_accessible')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isLastAccessibleProduct() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.accessibleProductCount === 1 && this.product.is_accessible;
  }

  @computed(
    'args.row.{accessRight,isSelected}',
    'product.is_editable',
    'isLastAccessibleProduct',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isNotEditable() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      // @ts-expect-error: Incorrect type
      this.args.row?.accessRight === 'admin' ||
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      !this.product?.is_editable ||
      this.isLastAccessibleProduct
    );
  }

  @computed('args.{row.products,column.columnProductType}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get product() {
    if (this.args.row !== undefined) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return this.args.row.products[this.args.column.columnProductType];
    }
    return null;
  }

  @computed('isNotEditable', 'args.row.isSelected')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showTooltip() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.isNotEditable || this.args.row.isSelected;
  }

  @action
  select(): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.row.onProductChange({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      value: !this.product.is_accessible,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      type: this.args.column.columnProductType,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      subscription: this.args.row.subscriptionId,
    });
  }

  <template>
    <div class="product-checkbox">
      {{#if this.showTooltip}}
        <PrismTooltip @side="top" @text={{this.hoverTooltipMessage}} />
      {{/if}}
      {{#if this.product}}
        {{#if this.isNotEditable}}
          <PrismIcon
            @color={{if this.product.is_accessible "success" "critical"}}
            @name={{if this.product.is_accessible "checkmark" "cross"}}
          />
        {{else}}
          <PrismCheckbox
            @checked={{this.product.is_accessible}}
            @disabled={{this.isDisabled}}
            @onChange={{this.select}}
          />
        {{/if}}
      {{else}}
        <PrismIcon @color="critical" @name="cross" />
      {{/if}}
    </div>
  </template>
}
